import { isDefined } from "../../helpers";
import { uid } from "@xbs/lib-state";
export default function (store, ev) {
    const { id, manual = false, skipStateCalc = false } = ev;
    const task = store.getTask(id);
    if (!task?.checked)
        return;
    const batch = [];
    const completed = store.getState().taskShape?.completed?.behavior || "auto";
    if (!ev.$meta) {
        ev.$meta = {};
    }
    if (!ev.$meta.batch) {
        ev.$meta.batch = uid();
    }
    const historyBatch = ev.$meta.batch;
    if (!manual && completed !== "manual" && !skipStateCalc) {
        if (isDefined(task.parent)) {
            store.getParentIds(id).forEach(parentId => {
                const parent = store.getTask(parentId);
                if (parent.checked) {
                    store.in.exec("uncheck-task", {
                        id: parentId,
                        skipStateCalc: true,
                        $meta: {
                            batch: historyBatch,
                            skipHistory: !!ev.$meta?.skipHistory,
                        },
                    });
                    batch.push({ ...store.getTask(parentId) });
                }
            });
        }
        if (store.hasChildren(id)) {
            store.getChildren({ id, tree: true }).forEach(child => {
                if (child.checked) {
                    store.in.exec("uncheck-task", {
                        id: child.id,
                        skipStateCalc: true,
                        $meta: {
                            batch: historyBatch,
                            skipHistory: !!ev.$meta?.skipHistory,
                        },
                    });
                    batch.push({ ...store.getTask(child.id) });
                }
            });
        }
    }
    store.in.exec("update-task", {
        id,
        task: {
            ...task,
            checked: false,
            completion_date: null,
        },
        skipStateCalc,
        skipProvider: skipStateCalc && !manual,
        batch,
        $meta: {
            skipHistory: true,
        },
    });
    return () => {
        store.in.exec("check-task", {
            ...ev,
            $meta: {
                ...ev.$meta,
                skipHistory: true,
            },
        });
    };
}
//# sourceMappingURL=uncheck.js.map